export const features = [
  {
    id: 1,
    title: 'Smart Product Organization',
    description: 'Browse through carefully organized product categories with a spreadsheet-inspired layout that makes finding what you need fast and intuitive.',
    icon: 'ri-layout-grid-line',
  },
  {
    id: 2,
    title: 'Curated Category Access',
    description: 'Access 14 dedicated product categories, each featuring handpicked items across fashion, accessories, and lifestyle products.',
    icon: 'ri-stack-line',
  },
  {
    id: 3,
    title: 'Seamless Navigation',
    description: 'Jump directly to any category with our intuitive dropdown menu and visual category cards, designed for effortless browsing.',
    icon: 'ri-compass-3-line',
  },
  {
    id: 4,
    title: 'Always Up to Date',
    description: 'Collections are continuously refreshed with the latest products, ensuring you never miss out on new arrivals and restocked favorites.',
    icon: 'ri-refresh-line',
  },
];

export const howItWorks = [
  {
    step: 1,
    title: 'Choose Your Category',
    description: 'Select from 14 product categories using the dropdown menu or category cards on the homepage.',
    icon: 'ri-cursor-line',
  },
  {
    step: 2,
    title: 'Browse the Collection',
    description: 'Explore curated product listings organized within your selected category for easy viewing.',
    icon: 'ri-eye-line',
  },
  {
    step: 3,
    title: 'Find What You Love',
    description: 'Discover premium items that match your style, from sneakers and hoodies to bags and fragrances.',
    icon: 'ri-heart-line',
  },
  {
    step: 4,
    title: 'Shop with Confidence',
    description: 'Click through to view full product details and make informed purchasing decisions.',
    icon: 'ri-shopping-bag-3-line',
  },
];

export const whoUses = [
  {
    id: 1,
    title: 'Fashion Enthusiasts',
    description: 'Stay ahead of trends with easy access to the latest fashion items across all major categories.',
    icon: 'ri-star-line',
  },
  {
    id: 2,
    title: 'Smart Shoppers',
    description: 'Find the best products efficiently without wasting time browsing cluttered marketplaces.',
    icon: 'ri-lightbulb-line',
  },
  {
    id: 3,
    title: 'Style Seekers',
    description: 'Discover coordinated outfits and accessories that elevate your personal style effortlessly.',
    icon: 'ri-palette-line',
  },
  {
    id: 4,
    title: 'Gift Hunters',
    description: 'Browse diverse categories to find the perfect gift for any occasion, from accessories to perfumes.',
    icon: 'ri-gift-line',
  },
  {
    id: 5,
    title: 'Streetwear Fans',
    description: 'Access premium streetwear including hoodies, jerseys, sneakers, and caps in one organized place.',
    icon: 'ri-fire-line',
  },
  {
    id: 6,
    title: 'Budget-Conscious Buyers',
    description: 'Compare options across categories to find quality products that fit your budget.',
    icon: 'ri-money-dollar-circle-line',
  },
];